// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BU32trx_cksqmd {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.Q_l7csSlPi8ecn {\n  width: unset;\n}\n.p2aJ0E_Hu6Aj4_ {\n  width: 200px;\n  z-index: 10;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardLink": "BU32trx_cksqmd",
	"boardCard": "Q_l7csSlPi8ecn",
	"searchCard": "p2aJ0E_Hu6Aj4_"
};
export default ___CSS_LOADER_EXPORT___;
